import './HowItWorks.css';

import aboutMeeting from '../../assets/alliatus/about-meeting.png';
import videocall from '../../assets/alliatus/videocall.png';

const ABOUT_CARDS = [
    {
        title: 'AI That Knows Your Goals',
        body: 'Tell Numus what you’re aiming for. It learns your skills, preferences, and non‑negotiables to recommend roles that actually fit.',
    },
    {
        title: 'Data, Not Guesswork',
        body: 'Market signals, hiring trends, and role requirements are woven into every match — so you apply where you have a real shot.',
    },
    {
        title: 'Your Network, Amplified',
        body: 'Surface warm intros, mutual connections, and company signals from your network so outreach feels personal — not cold.',
    },
];

const STEPS = [
    {
        num: '01',
        title: 'Build Your Profile',
        body: 'Share your experience, target roles, and what “next” looks like for you. Takes a few minutes.',
        tone: 'yellow',
    },
    {
        num: '02',
        title: 'Connect Your Data',
        body: 'Link your resume and network signals so Numus can match you with roles using AI and real-world context.',
        tone: 'white',
    },
    {
        num: '03',
        title: 'Get Matched Daily',
        body: 'Receive prioritized opportunities scored on fit, timing, and network advantage — not just keyword spam.',
        tone: 'outline',
    },
    {
        num: '04',
        title: 'Apply With Momentum',
        body: 'Use tailored outreach, application tracking, and next-step prompts to move from match to interview faster.',
        tone: 'white',
    },
];

const INCLUDED = [
    'AI-powered role matching',
    'Network & warm-intro insights',
    'Application tracking dashboard',
    'Resume and outreach suggestions',
    'Market and company signals',
];

function HowItWorks() {
    return (
        <>
            <section className="al-section" id="how-it-works">
                <div className="al-shell">
                    <div className="al-section-head al-section-head--center">
                        <p className="al-eyebrow">What is <span className="al-eyebrow--strong">Numus</span>?</p>
                        <h2 className="al-display">
                            <span className="al-em">Not</span> Another Job Board.
                        </h2>
                    </div>
                    <div className="al-about-grid">
                        <div className="al-about-media">
                            <img
                                src={aboutMeeting}
                                alt="People collaborating on a laptop while reviewing opportunities"
                            />
                        </div>
                        <div className="al-about-copy">
                            <p className="al-body al-about-intro">
                                Numus is a job search assistant that uses AI, market data, and your
                                professional network to help you find — and win — your next role faster.
                            </p>
                            {ABOUT_CARDS.map((card) => (
                                <article className="al-info-card" key={card.title}>
                                    <p className="al-eyebrow">{card.title}</p>
                                    <p className="al-body">{card.body}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="al-section">
                <div className="al-shell">
                    <div className="al-how-head">
                        <p className="al-eyebrow">How It Works</p>
                        <h2 className="al-display">
                            From Profile to Offer — <span className="al-em">Step by Step</span>
                        </h2>
                    </div>
                    <div className="al-how-grid">
                        {STEPS.map((step) => (
                            <article
                                className={`al-step al-step--${step.tone} al-step--${step.num}`}
                                key={step.num}
                            >
                                <p className="al-step-num">{step.num}</p>
                                <p className="al-eyebrow">{step.title}</p>
                                <p className="al-body">{step.body}</p>
                            </article>
                        ))}
                        <div className="al-how-photo">
                            <img src={videocall} alt="Person reviewing job matches on a laptop from home" />
                        </div>
                        <div className="al-included">
                            <p className="al-eyebrow">What’s included</p>
                            <ul>
                                {INCLUDED.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default HowItWorks;
